import { render, staticRenderFns } from "./ReviewDependents.vue?vue&type=template&id=c29562a2&scoped=true"
import script from "./ReviewDependents.vue?vue&type=script&lang=ts"
export * from "./ReviewDependents.vue?vue&type=script&lang=ts"
import style0 from "./ReviewDependents.vue?vue&type=style&index=0&id=c29562a2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c29562a2",
  null
  
)

export default component.exports